import { Injectable } from '@angular/core';

export interface ChatbotConfig {
  tenantId: string;
  apiBaseUrl: string;
  apiKey?: string;
  chatbotName?: string;
  displayName?: string;
  introMessage?: string;
  position?: 'bottom-right' | 'bottom-left';
  locale?: string;
  theme?: {
    mode?: 'light' | 'dark';
    primaryColor?: string;
  };
  ticketUrl?: string;
  enableCsat?: boolean;
}

export interface ChatbotUser {
  name: string;
  email: string;
}

export interface ServerChatbot {
  name: string;
  display_name: string;
  intro_message: string;
}

// Shape returned by GET /v1/config
export interface ServerConfig {
  tenant_id?: string;
  theme?: { mode?: 'light' | 'dark'; primary_color?: string; };
  position?: 'bottom-right' | 'bottom-left';
  supported_languages?: string[];
  ticket_url?: string | null;
  enable_csat?: boolean;
  chatbots?: ServerChatbot[];
}

@Injectable({
  providedIn: 'root',
})
export class ChatbotConfigService {
  private config: ChatbotConfig | null = null;
  private user: ChatbotUser | null = null;

  configure(config: ChatbotConfig): void {
    this.config = config;
  }

  // Identity of the signed-in user; required to submit a support ticket (POST /v1/escalate).
  setUser(user: ChatbotUser | null): void {
    this.user = user;
  }

  getUser(): ChatbotUser | null {
    return this.user;
  }

  getConfig(): ChatbotConfig | null {
    return this.config;
  }

  applyServerConfig(server: ServerConfig): void {
    if (!this.config) return;
    if (server.ticket_url)          this.config = { ...this.config, ticketUrl: server.ticket_url };
    if (server.enable_csat != null)  this.config = { ...this.config, enableCsat: server.enable_csat };
    if (server.position)            this.config = { ...this.config, position: server.position };
    if (server.chatbots?.length) {
      const [bot] = server.chatbots;
      this.config = {
        ...this.config,
        chatbotName: bot.name,
        displayName: bot.display_name,
        introMessage: bot.intro_message,
      };
    }
    if (server.theme) {
      this.config = {
        ...this.config,
        theme: {
          ...this.config.theme,
          ...(server.theme.mode && { mode: server.theme.mode }),
          ...(server.theme.primary_color && { primaryColor: server.theme.primary_color }),
        },
      };
    }
  }
}
